import React, { Component } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Chip from "@material-ui/core/Chip";
import Pagination from "@material-ui/lab/Pagination";

import BookIcon from "../../../Assets/Logo/BookIcon.svg";
import { useStyles } from "./UserLibrary.css";
import UserHeader from "../../../Components/NavBar/User/UserHeader/UserHeader";
import { url } from "../../../Config/Config";
import CustomEmptyMessage from "../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import CustomSiteLoader from "../../../Components/CustomSiteLoader/CustomSiteLoader";
import IssuedBook from "./IssuedBook/IssuedBook";
import { getUserRefreshToken } from "../../../Redux/Actions/actions";
import PageTitle from "../../../Components/PageTitle/PageTitle";

class UserLibrary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      books: [],
      issued: [],
      bookName: "",
      currentPage: 1,
      postPerPage: 6,
    };
  }

  componentDidMount() {
    this.getLibraryBooks();
  }

  getLibraryBooks = async () => {
    try {
      const responseStudent = await Axios.get(
        `${url}/api/students/${this.props.userId}`,
        {
          headers: { Authorization: `Bearer ${this.props.userToken}` },
        }
      );
      const response = await Axios.get(`${url}/api/books`, {
        headers: {
          Authorization: `Bearer ${this.props.userToken}`,
        },
      });
      if (response.data.books.length !== 0) {
        this.setState({
          books: response.data.books,
          isEmpty: false,
        });
      } else {
        this.setState({
          books: [],
          isEmpty: true,
        });
      }
      let issued = [];
      for (let i = 0; i <= response.data.books.length - 1; i++) {
        for (let j = 0; j <= response.data.books[i].loans.length - 1; j++) {
          if (
            response.data.books[i].loans[j].studentId ===
            responseStudent.data.student._id
          ) {
            issued.push({
              title: response.data.books[i].title,
              author: response.data.books[i].author,
              publication: response.data.books[i].publication,
              issuedDate: response.data.books[i].loans[j].issuedDate,
              dueDate: response.data.books[i].loans[j].dueDate,
              returnDate: response.data.books[i].loans[j].returnDate
                ? response.data.books[i].loans[j].returnDate
                : "",
            });
          }
        }
      }
      this.setState({ issued });
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.getLibraryBooks();
      }
    }
  };

  handlePage = (e, value) => {
    this.setState({
      currentPage: value,
    });
  };

  render() {
    const { classes } = this.props;
    const { books, issued, currentPage, postPerPage } = this.state;
    let filtered = this.state.books.filter((filter) => {
      return filter.title.indexOf(this.state.bookName) !== -1;
    });
    return (
      <div className={classes.root}>
        <UserHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          <div className={classes.sectionDesktop}>
            <PageTitle title="Library" refreshUrl={this.props.match.url} />
          </div>
          {books.length !== 0 ? (
            <div>
              {issued.length !== 0 && (
                <div>
                  <div style={{ fontSize: 18, fontWeight: "bold" }}>
                    Issued Books
                  </div>
                  <IssuedBook issued={issued} />
                </div>
              )}
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                Library Books
              </div>
              <TextField
                name="bookName"
                type="text"
                required
                fullWidth
                label="Search By Book Name"
                variant="outlined"
                margin="normal"
                className={classes.inputWithoutMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.bookName}
                onChange={(e) => this.setState({ bookName: e.target.value })}
              />
              <br />
              <Grid container spacing={3}>
                {filtered
                  .slice(
                    (currentPage - 1) * postPerPage,
                    (currentPage - 1) * postPerPage + postPerPage
                  )
                  .map((book, index) => (
                    <Grid item xs={12} sm={12} md={4} lg={4} xl={4} key={index}>
                      <Paper className={classes.paper}>
                        <img
                          src={BookIcon}
                          alt={book.title}
                          style={{ width: 70, height: 70 }}
                        />
                        <div className={classes.sectionDesktop}>
                          <div className={classes.bookStyle}>
                            <div>{book.title}</div>
                            <div>{book.author}</div>
                            <div>{book.publication}</div>
                            {book.currentStock !== 0 ? (
                              <Chip
                                label="Available"
                                style={{
                                  backgroundColor: "green",
                                  color: "#fff",
                                }}
                              />
                            ) : (
                              <Chip
                                label="Not Available"
                                style={{
                                  backgroundColor: "red",
                                  color: "#fff",
                                }}
                              />
                            )}
                          </div>
                        </div>
                        <div className={classes.sectionMobile}>
                          <div className={classes.bookStyle}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <div style={{ marginRight: 10 }}>
                                {book.title}
                              </div>
                              {book.currentStock !== 0 ? (
                                <Chip
                                  label="Available"
                                  style={{
                                    backgroundColor: "green",
                                    color: "#fff",
                                  }}
                                />
                              ) : (
                                <Chip
                                  label="Not Available"
                                  style={{
                                    backgroundColor: "red",
                                    color: "#fff",
                                  }}
                                />
                              )}
                            </div>
                            <div>{book.author}</div>
                            <div>{book.publication}</div>
                          </div>
                        </div>
                      </Paper>
                    </Grid>
                  ))}
              </Grid>
              <br />
              <div className={classes.toolbarStyle}>
                <Pagination
                  count={Math.ceil(this.state.books.length / postPerPage)}
                  color="secondary"
                  page={currentPage}
                  boundaryCount={1}
                  onChange={this.handlePage}
                  showFirstButton
                  showLastButton
                />
              </div>
            </div>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(UserLibrary));
